import React, { useState, useEffect } from 'react';
import NavigationBar from './NavigationBar';
import HamburgerMenu from './HamburgerMenu';

function PrivacyPolicyPage({ navigateTo, goBack, userProfile, isLoggedIn }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
      padding: isMobile ? '20px 16px 60px' : '40px 20px 80px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {!isMobile && <NavigationBar currentPage="privacy" isLoggedIn={isLoggedIn} navigateTo={navigateTo} userProfile={userProfile} />}
      {isMobile && <HamburgerMenu currentPage="privacy" isLoggedIn={isLoggedIn} navigateTo={navigateTo} userProfile={userProfile} />}
      
      <div style={{
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '32px',
          marginTop: isMobile ? '50px' : '20px',
          color: 'white'
        }}>
          <h1 style={{
            fontSize: isMobile ? '28px' : '42px',
            fontWeight: isMobile ? '700' : '800',
            margin: '0 0 12px 0',
            letterSpacing: '-0.5px'
          }}>
            Privacy Policy
          </h1>
          <p style={{
            fontSize: '14px',
            opacity: 0.9,
            margin: '0',
            fontWeight: '500'
          }}>
            Last updated: January 2026
          </p>
        </div>

        {/* Privacy Policy Content */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: isMobile ? '28px 24px' : '40px 48px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          lineHeight: '1.8'
        }}>
          
          {/* Introduction */}
          <div style={{ marginBottom: '32px' }}>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              SudokuMatch ("we", "us", or "our") operates the SudokuMatch website and application. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our service.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              By using SudokuMatch, you agree to the collection and use of information in accordance with this policy.
            </p>
          </div>

          {/* Section 1 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              1. Information We Collect
            </h2>
            
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              1.1 Information You Provide
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 12px 0'
            }}>
              When you create an account, we collect:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Email address</li>
              <li style={{ marginBottom: '8px' }}>Username (display name)</li>
              <li style={{ marginBottom: '8px' }}>Password (encrypted and never stored in plain text)</li>
              <li>Optional profile information you choose to provide</li>
            </ul>

            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              1.2 Usage Information
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 12px 0'
            }}>
              We automatically collect information about how you use SudokuMatch:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Puzzle completion times and scores</li>
              <li style={{ marginBottom: '8px' }}>Game statistics and performance data</li>
              <li style={{ marginBottom: '8px' }}>Device information (browser type, operating system)</li>
              <li style={{ marginBottom: '8px' }}>IP address and general location (country/region)</li>
              <li>Interaction data (pages visited, features used)</li>
            </ul>

            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              1.3 Cookies and Local Storage
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We use cookies and browser local storage to maintain your session, remember your preferences, and improve your experience. You can disable cookies in your browser settings, but this may affect functionality.
            </p>
          </div>

          {/* Section 2 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              2. How We Use Your Information
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 12px 0'
            }}>
              We use your information to:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Provide and maintain the SudokuMatch service</li>
              <li style={{ marginBottom: '8px' }}>Create and manage your account</li>
              <li style={{ marginBottom: '8px' }}>Track your puzzle performance and display leaderboards</li>
              <li style={{ marginBottom: '8px' }}>Send service-related notifications (when necessary)</li>
              <li style={{ marginBottom: '8px' }}>Improve our service and develop new features</li>
              <li style={{ marginBottom: '8px' }}>Prevent fraud and ensure fair play</li>
              <li>Respond to your questions and support requests</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              3. Information Sharing and Disclosure
            </h2>
            
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              3.1 Public Information
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              Your username and puzzle completion times are publicly visible on leaderboards. This is essential to the competitive nature of SudokuMatch. You can choose your display name when creating your account.
            </p>

            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              3.2 Service Providers
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              We use trusted third-party services to help operate SudokuMatch:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Supabase (database and authentication)</li>
              <li style={{ marginBottom: '8px' }}>Hosting and infrastructure providers</li>
              <li>Analytics services (to understand usage patterns)</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              These providers are contractually obligated to protect your data and use it only for providing services to us.
            </p>

            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              3.3 Legal Requirements
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We may disclose your information if required by law, court order, or government request, or if necessary to protect our rights, prevent fraud, or ensure user safety.
            </p>
          </div>

          {/* Section 4 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              4. Data Security
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              We take data security seriously and implement industry-standard measures to protect your information:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>All data transmitted between you and our servers is encrypted using HTTPS/SSL</li>
              <li style={{ marginBottom: '8px' }}>Passwords are hashed and never stored in plain text</li>
              <li style={{ marginBottom: '8px' }}>Access to personal data is restricted to authorized personnel only</li>
              <li>Regular security audits and updates</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              However, no method of transmission over the internet is 100% secure. While we strive to protect your data, we cannot guarantee absolute security.
            </p>
          </div>

          {/* Section 5 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              5. Your Rights and Choices
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 12px 0'
            }}>
              You have the following rights regarding your personal information:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}><strong>Access:</strong> You can view your account information and game statistics at any time</li>
              <li style={{ marginBottom: '8px' }}><strong>Correction:</strong> You can update your username and email address in your account settings</li>
              <li style={{ marginBottom: '8px' }}><strong>Deletion:</strong> You can request account deletion by contacting us at hello@sudokumatch.com</li>
              <li style={{ marginBottom: '8px' }}><strong>Opt-out:</strong> You can disable cookies through your browser settings</li>
              <li><strong>Portability:</strong> You can request a copy of your data in a portable format</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              Please note that leaderboard data may be retained even after account deletion to maintain historical integrity and prevent manipulation.
            </p>
          </div>

          {/* Section 6 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              6. Children's Privacy
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              SudokuMatch is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately and we will delete it.
            </p>
          </div>

          {/* Section 7 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              7. Data Retention
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              We retain your account information and game data for as long as your account is active. If you delete your account, most personal information is removed within 30 days. Leaderboard entries may be retained longer to maintain historical records and prevent score manipulation.
            </p>
          </div>

          {/* Section 8 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              8. International Data Transfers
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              SudokuMatch is operated from the United Kingdom. If you access our service from outside the UK, your information may be transferred to, stored, and processed in the UK or other countries where our service providers operate. By using SudokuMatch, you consent to this transfer.
            </p>
          </div>

          {/* Section 9 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              9. Changes to This Privacy Policy
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              We may update this Privacy Policy from time to time. We will notify you of any significant changes by:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0',
              paddingLeft: '24px'
            }}>
              <li style={{ marginBottom: '8px' }}>Updating the "Last updated" date at the top of this policy</li>
              <li style={{ marginBottom: '8px' }}>Posting a notice on the website</li>
              <li>Sending an email notification (for material changes)</li>
            </ul>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0'
            }}>
              Your continued use of SudokuMatch after changes are posted constitutes acceptance of the updated policy.
            </p>
          </div>

          {/* Section 10 */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1F2937',
              margin: '0 0 16px 0',
              letterSpacing: '-0.3px'
            }}>
              10. Contact Us
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#4B5563',
              margin: '0 0 16px 0'
            }}>
              If you have any questions, concerns, or requests regarding this Privacy Policy or how we handle your data, please contact us:
            </p>
            <div style={{
              background: '#F9FAFB',
              padding: '16px 20px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB'
            }}>
              <p style={{
                fontSize: '16px',
                color: '#1F2937',
                margin: '0 0 8px 0',
                fontWeight: '600'
              }}>
                SudokuMatch
              </p>
              <p style={{
                fontSize: '16px',
                color: '#4B5563',
                margin: '0 0 4px 0'
              }}>
                Email: hello@sudokumatch.com
              </p>
              <p style={{
                fontSize: '16px',
                color: '#4B5563',
                margin: '0'
              }}>
                Location: United Kingdom
              </p>
            </div>
          </div>

          {/* Final Note */}
          <div style={{
            background: '#EFF6FF',
            padding: '20px 24px',
            borderRadius: '8px',
            border: '1px solid #BFDBFE'
          }}>
            <p style={{
              fontSize: '15px',
              color: '#1E40AF',
              margin: '0',
              fontWeight: '500'
            }}>
              <strong>Your Privacy Matters:</strong> We are committed to transparency and protecting your personal information. If you have any concerns about how your data is handled, please don't hesitate to reach out.
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div style={{
          marginTop: '32px',
          textAlign: 'center'
        }}>
          <button
            onClick={() => goBack()}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              color: 'white',
              padding: '12px 32px',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.25)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.15)';
            }}
          >
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
